module.exports = __webpack_public_path__ + "img/bar-chart.628b969e.svg";